import cypressIds from 'Components/cypress_ids.json';
import { useVehiclePhotosByKind } from 'Components/Gallery';
import type { GalleryImageWithTitle } from 'Components/Gallery/MainGallery/MainGallery';
import BasicThumbnail from 'Components/Thumbnail/BasicThumbnail';
import { triggerSectionImageClickedEvent } from 'Services/analytics/events/galleryEventsRedesign';
import { applyCypressData } from 'Utilities/helpers';

import { useGalleryTrigger } from '../../../Components/GalleryProvider';

import styles from './WheelsAndTyresImages.module.scss';

interface WheelsAndTyresImagesProps {
	cypressId?: string;
	kinds: string[];
	title: string;
}
export const WheelsAndTyresImages: React.FC<WheelsAndTyresImagesProps> = ({ cypressId = '', kinds, title }) => {
	const images = useVehiclePhotosByKind(kinds);

	const openGallery = useGalleryTrigger();

	const handleOnClick = ({ id, kind }: GalleryImageWithTitle) => {
		openGallery({ id });
		triggerSectionImageClickedEvent({ kind });
	};
	return (
		<div className={styles.container} {...applyCypressData(cypressId)}>
			<h3 {...applyCypressData(cypressIds.text.galleryTitle)} className={styles.heading}>
				{title}
			</h3>

			<div className={styles.imageWrapper}>
				{images.map((image) => (
					<BasicThumbnail
						{...applyCypressData(cypressIds.images.galleryPhoto)}
						key={image.id}
						authenticated
						alt={image.kind}
						className={styles.thumb}
						height={279}
						image={{
							presets: image.presetsArray,
							url: image.url,
						}}
						imgAttributes={{ 'aria-label': image.kind }}
						onClick={() => handleOnClick(image)}
						rootComponent={'WheelsAndTyresImages'}
						width={372}
					/>
				))}
			</div>
		</div>
	);
};
